;


window.newTab = function(url, tabname) {
    var existing = window.open('', tabname);
    if (existing == null || existing.closed) {
        window.open(url, tabname);
        return false;
    }
    setTimeout(function() {
        //existing.close();
        setTimeout(function() {
            var windowObjectReference = window.open(url, tabname);
            setTimeout(function() {
                windowObjectReference.focus();
            }, 400);

        }, 400);
    }, 400);
    return false;
};


/**
 * oeffnet den responsive filemanager und fuegt das dort ausgewaehlte element als quelle in die uebergebene ID ein.
 * @param idToUse {string} id eines dom elementes
 */
window.openFileManager = (idToUse) => {
    window.fm = window.open("/ajax/ResponsiveFileManager/filemanager/dialog.php?type=1&relative_url=1&popup=1&field_id=" + idToUse, 'Filemanager',
        'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,copyhistory=no,resizable=yes');
    fm.responsive_filemanager_callback = responsive_filemanager_callback;
}

/**
 * funktion wird ausgefuehrt nachdem man von dem responsive filemanager zurueckkommt
 * @param idToUse {string} id eines dom elementes
 */
window.responsive_filemanager_callback = (idToUse) => {
    $('input.imageSrc').each(function() {
        var targetId = $(this).attr('data-to-fill');
        var url = "/data/files/" + $(this).val().replace(/^\/data\/files\//, "");
        $(this).val(url);
        $('#' + targetId).attr('src', url);
    });
    window.fm.close();
}

window.registerPegelDropDown = ($item) => {
    $item.selectmenu({
        width: '80%',
        change: function(event, ui) {
            $(this).prev().prev().val($(ui.item.element[0]).attr('data-id'));
            $(this).prev().val($(ui.item.element[0]).val());
            var cb = $(this).attr('data-callback');
            if (cb !== undefined && cb.length > 0) {
                eval(cb);
            }
            document.dispatchEvent(new CustomEvent('PegelDropDown:change', { detail: { jqItem: ui} }));
            this.dispatchEvent(new CustomEvent('PegelSelect:change', { detail: { jqItem: ui} }));
        }
    });
}

window.registerScadaDropDown = ($item) => {
    $item.selectmenu({
        width: '80%',
        change: function(event, ui) {
            $(this).prev().prev().val($(ui.item.element[0]).attr('data-id'));
            $(this).prev().val($(ui.item.element[0]).val());
            var cb = $(this).attr('data-callback');
            if (cb !== undefined && cb.length > 0) {
                eval(cb);
            }
        }
    });
}

window.registerAllDropDown = ($item) => {
    $item.selectmenu({
        width: '80%',
        change: function(event, ui) {
            $(this).prev().prev().val($(ui.item.element[0]).attr('data-id'));
            $(this).prev().val($(ui.item.element[0]).attr('data-type'));
            var cb = $(this).attr('data-callback');
            if (cb !== undefined && cb.length > 0) {
                eval(cb);
            }
        }
    });
}

window.getItemById = (id) => {
    return $($('li div[data-id="' + id + '"]')[0]).clone(true).addClass('block');
}

window.removeTemplateBlockById = (id) => {
    $('div.cms-block[data-id="' + id + '"]').remove()
}


window.initStationSelect = (container) => {
    var stations = [];
    var stationSelected = {};
    $(container).find('.station-multi-select option').each(function(i, el) {
        stations.push({
            label: el.text,
            value: el.value,
            type: $(el).attr('data-type')
        });
    });
    $(container).find('.auto-stations').autocomplete({
        source: stations,
        autoFocus: true,
        select: function(event, ui) {
            stationSelected = ui.item;
            event.target.value = ui.item.label;
            return false;
        }
    }).autocomplete("instance")._renderItem = function(ul, item) {
        return $("<li>")
            .append("" + item.label + " [" + item.type + "]")
            .appendTo(ul);
    };
    $(container).find('.station-add').click(function(event) {
        var container = $(this).closest('.station-outer').find('.sorted-list');
        if (stationSelected) {
            var dummy = $('<div class="row no-margin"><div class="col-xs-12"><i class="icon-trash pointer del-row" title="Station entfernen"></i><input type="hidden" class="stationId" data-name="stationId-" value="' + stationSelected.value + '"><input type="hidden" class="type" data-name="type-" value="' + stationSelected.type + '">' + stationSelected.label + '</div></div>');
            //$('.sorted-list').append(dummy);
            container.append(dummy);
            dummy.find('.del-row').click(function(event) {
                $(this).parent().parent().remove();
            })
            //station_reorder($('.sorted-list'));
            station_reorder($(container));

        }
    });
    $(container).find('.sorted-list').sortable({
        update: function(event, ui) {
            station_reorder(this);
        }

    });

    function station_reorder(list) {
        $(list).find('>.move,>.row').each(function(i, el) {
            $(el).find('input.stationId').attr('data-name', 'stationId-' + (i + 1));
            $(el).find('input.type').attr('data-name', 'type-' + (i + 1));
        });
    }
}

window.setTimeout(init,200);

function init() {
    document.querySelectorAll('.import-list').forEach(function(entry) {
        entry.querySelector('i.toggle').addEventListener('click', function(ev) {
            /** @type {HTMLElement} */
            var el = ev.target;
            el.classList.toggle('icon-down-circle');
            el.classList.toggle('icon-up-circle');
            entry.querySelector('.filelist').classList.toggle('hidden');
        });
    });
    $.ajaxSetup({ cache: false });
    window.page = {};
    page.id = $('#page-id').val();
    $('#clearPageCache').on('click', function(event) {
        var pid = ($(this).attr('data-id'));

        $.ajax({
            cache: false,
            type: "POST",
            url: '/Handler/HvD/Cache',
            data: {
                data: {
                    'type': 'del',
                    'pid': pid
                }
            }

        }).done(function(data) {
            if (data === 'ok') {
                $('#worker-message').html('Cache wurde gelöscht und die Seite wird neu geladen.');
                $('#worker').show();
                document.location.reload();
            }
        });
        return false;
    });

    /* Update Reports */
    $('.update-report').on('click', updateReports);

    function updateReports() {
        $.ajax({
            type: "POST",
            url: '/Handler/Report',
            data: {
                data: {
                    'action': 'update'
                }
            },
        }).done(function(data) {
            // toast gespeichert
            if (JSON.parse(data).update === 'ok') {
                tools.toast('Reports', 'Reports aktualisiert. Seite wird neu geladen');
                document.location.reload();
            } else {
                tools.toast('Reports', 'Bei der aktualisierung der Reports ist ein Fehler aufgetreten');

            }
        });
    }

    /**
     * jQueryUi Dialog immer psosition:fixed
     */
    $.ui.dialog.prototype._oldinit = $.ui.dialog.prototype._init;
    $.ui.dialog.prototype._init = function() {
        $(this.element).parent().css('position', 'fixed');
        $(this.element).dialog("option", {
            resizeStop: function(event, ui) {
                var position = [(Math.floor(ui.position.left) - $(window).scrollLeft()),
                    (Math.floor(ui.position.top) - $(window).scrollTop())
                ];
                $(event.target).parent().css('position', 'fixed');
                $(event.target).dialog('option', 'position', position);
                return true;
            }
        });
        this._oldinit();
    };
    /**
     * choosen.js
     * Selector im Cockpit. Auswahl der Stationen für das Widget
     */
    var config = {
        '.chosen-select': {
            max_selected_options: 5
        }
    };
    for (var selector in config) {
        $(selector).chosen(config[selector]);
    }
    /*  Toggle-Checkbox */
    $(".checkbox-toggle").bootstrapSwitch({
        onText: 'An',
        offText: 'Aus',
        onInit: function(el, state) {
            if (!this.checked) {
                $('#' + this.dataset.toggleBox).fadeToggle(400);
            }
        },
        onSwitchChange: function(event, state) {
            $('#' + this.dataset.toggleBox).fadeToggle(500);
            event.currentTarget.value = state ? 'on' : 'off';
        }
    });

    var $saveWidget = $('#saveWidget');
    if ($saveWidget.length === 1) {
        $saveWidget.on('click', function(event) {
            var items = $('.hwp-widget .hwp-value');
            var postData = {};
            items.each(function(i, el) {
                var $el = $(el);
                if ($el.attr('data-name') === 'infoText' || $el.attr('data-name') === 'moreInfoText') {
                    postData[$el.attr('data-name')] = $el.html();
                } else {
                    postData[$el.attr('data-name')] = $el.val();
                }
            });

            // Widgetdaten speichern
            $.ajax({
                type: "POST",
                url: '/Handler/HvD/HWPWidget',
                data: postData
            }).done(function(data) {
                // toast gespeichert
                tools.toast('HWP-Widget', 'Daten gespeichert');
            });
        });
        $('#renewWidget').click(function(event) {
            $.ajax({
                type: "GET",
                url: '/?public=hp_widget'
            }).done(function(data) {
                // toast gespeichert
                tools.toast('HWP-Widget', 'Widget aktualisiert');
            });

        });
    }

    /* Wiedervorlage Datum */
    $('#page-resubmission').datetimepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: 'dd.mm.yy',
        timeFormat: "HH:mm"
    });
    $("#page-resubmission").datepicker("option", $.datepicker.regional['de']);
    $("#page-resubmission").val($("#page-resubmission").attr('data-value'));

    var dlgDataAvaible = $('#dlg_dataHole').dialog({
        autoOpen: false,
        modal: true,
        buttons: [{
            text: 'Ok',
            class: 'ok',
            click: function() {
                var url = '/Handler/HvD/GlobalConf';
                var postData = Array();
                postData.push({
                    name: 'datahole',
                    value: $('#datahole').val()
                });
                postData.push({
                    name: 'stationloss',
                    value: $('#stationloss').val()
                });
                var data = {
                    data: {
                        type: 'save',
                        fields: postData
                    }
                };
                $.ajax({
                    type: "POST",
                    url: url,
                    data: data
                }).done(function(data) {
                    if (data === 'ok') {
                        dlgDataAvaible.dialog("close");
                        tools.toast('Datenlücke', 'Daten gespeichert');
                        location.reload();
                    }
                });
            }
        }, {
            text: 'Abbrechen',
            class: 'cancel',
            click: function() {
                $(this).dialog("close");
            }
        }]
    });
    dlgDataAvaible.parent().addClass('overflow');
    $("#datahole, #stationloss").selectmenu({
        width: 'auto',
        maxHeight: '2em'
    });
    $('.edit-data-avaible').click(function(event) {
        dlgDataAvaible.dialog('open');
    });
    if ($('.cmsZone').length > 0) {
        window.focus();
        /* SELECT-Listen */
        var sel = $("#page-parentId").selectmenu({
            height: '10em'
        }).data("ui-selectmenu");
        if (sel) {
            sel._renderItem = function(ul, item) {
                var li = $("<li>").html('<div style="width:18em;float: left;" >' + item.label + '</div><div style="position:	relative; left:	10em;">' + $(item.element).attr('data-path') + '</div>');
                return li.appendTo(ul);
            };
        }
        $("#page-userId").selectmenu();
        $("#page-acv").selectmenu(
            {
                width: '100%'
            }
        );

        /* Dropdown für Pegelsationen. data-id enthält die ID's der Pegel */
        registerPegelDropDown($('.pegel-dropdown'));
        registerScadaDropDown($('.scada-dropdown'));
        registerAllDropDown($('.all-dropdown'));
        /* Autocomplete Liste aller Stationen */
        initStationSelect($('.cmsZone'));
        /* / SELECT-Listen */


        /* Drag	& Drop & Sortable */
        $('.cmsDrag').draggable({
            helper: function(e) {
                return $('<div class="cms-new-drag" data-type="' + $(e.target).attr('data-type') + '" data-id="' + $(e.target).attr('data-id') + '" data-control="' + $(e.target).attr('data-control') + '" data-extra="' + $(e.target).attr('data-extra') + '">').addClass('block').text($(e.target).text());
            },
            connectToSortable: ".cmsZone"
        });

        $('.cms-trash').droppable({
            placeholder: 'block-placeholder',
            over: function(event, ui) {
                $('.cms-trash').css('background-color', '#8796c1');
            },
            out: function(event, ui) {
                $('.cms-trash').css('background-color', '#e9ecf5');
            },
            drop: function(event, ui) {
                $('.cms-trash').css('background-color', '#e9ecf5');
                let maxTries = 10;
                let elToRemove = ui.draggable.next();
                while (elToRemove.length && elToRemove[0].tagName !== 'HR' && maxTries > 0) {
                    elToRemove = elToRemove.next();
                }
                elToRemove.remove();
                ui.draggable.remove();
            }
        });

        $('.cmsZone').sortable({
            handle: '.cms-block-picker',
            placeholder: 'block-placeholder',
            helper: function(event, ui) {
                $(ui).css({
                    'max-width': '20em',
                    'max-height': '10em',
                    'overflow': 'hidden',
                    'background-color': '#fff'
                });
                return ui;
            },
            cursorAt: {
                top: 10,
                left: 50
            },

            over: function(event, ui) {
                $(ui.item).css('max-width', '');
            },
            out: function(event, ui) {
                $(ui).css('max-width', '20em');
            },
            stop: function(event, ui) {
                //$(ui).css('max-width', '');
                $(ui).css({
                    'max-width': '',
                    'max-height': '',
                    'overflow': '',
                    'background-color': ''
                });
            },
            remove: function(event, ui) {
                this.refreshPositions();
            },
            receive: function(event, ui) {
                var newIndex = $(this).data("ui-sortable").currentItem.index()
            },
            update: function(event, ui) {
                $(ui).css('max-width', '');
                var dropTitle = ui.item.context.textContent;
                if ($(ui.item).hasClass('block')) {
                    ui.item.removeClass('block');
                    ui.item.removeClass('cms-new-drag');
                    ui.item.addClass('cms-block');
                    ui.item[0].style = '';
                    ui.item.html('<div style="text-align:center"><img src="/img/loader.gif"	alt="Lade Daten	..." />');
                    var dataId = ui.item.attr('data-id');
                    var dataType = ui.item.attr('data-type');
                    var dataControl = ui.item.attr('data-control');
                    var dataExtra = ui.item.attr('data-extra');
                    $.ajax({
                            type: 'POST',
                            url: '/Handler/HvD/NewItem',
                            data: {
                                id: dataId,
                                type: dataType,
                                control: dataControl,
                                extra: dataExtra
                            }
                        })
                        .done(function(data, state, jqxhr) {
                            ui.item.html('<div class="cms-block-picker" title="' + dropTitle + '"></div>' + data);
                            ui.item.tooltip();
                            ui.item.css({
                                width: '',
                                height: ''
                            });

                            var editor = $(ui.item).find('div.ckedit');
                            if (editor.length > 0) {
                                CKEDITOR.disableAutoInline = true;
                                for (var ei = 0; ei < editor.length; ei++) {
                                    CKEDITOR.inline(editor[ei]);
                                }
                            }

                            if ($(ui.item).find('.pegel-dropdown')) {
                                registerPegelDropDown($(ui.item).find('.pegel-dropdown'));
                            }
                            var stammdaten = $(ui.item).find('.edit-stammdaten');
                            if (stammdaten.length > 0) {
                                initStammDaten();
                            }
                            var areaEdit = $(ui.item).find('.edit-diagramArea');
                            if (areaEdit.length > 0) {
                                let customEvent = new CustomEvent('registerAreaClick', {
                                    detail: {
                                        item: areaEdit[0]
                                    }
                                });
                                window.dispatchEvent(customEvent);
                            }
                            var privateStation = $(ui.item).find('.station-multi-select');
                            if (privateStation.length > 0) {
                                initStationSelect(ui.item);
                            }
                            var textBaustein = $(ui.item).find('.dlgTextbausteine');
                            if (textBaustein.length > 0) {
                                initTextbausteine(ui.item);
                            }
                            if ($(ui.item).find('.scada-dropdown')) {
                                registerScadaDropDown($('.scada-dropdown'));
                            }
                            if ($(ui.item).find('.btnGeo')) {
                                setGeoClick();
                            }
                            if ($(ui.item).find('.toast-outer')) {
                                Toast.init();
                            }
                            // col-drop-zone
                            var $colDropZones = $(ui.item).find('div.col-drop-zone');
                            if ($colDropZones.length > 0) {
                                $colDropZones.droppable({
                                    hoverClass: "drop-hover",
                                    drop: function(event, ui) {
                                        // Ajax	again
                                        var dataId = ui.draggable.attr('data-id');
                                        var dataType = ui.draggable.attr('data-type');
                                        var dropZoneItem = $(this);
                                        dropZoneItem.html('<div	style="text-align:center"><img src="/img/loader.gif" alt="Lade Daten ..." />');
                                        $.ajax({
                                                type: 'POST',
                                                url: '/ajax/page-new.php',
                                                data: {
                                                    id: dataId,
                                                    type: dataType
                                                }
                                            })
                                            .done(function(data, state, jqxhr) {
                                                ui.draggable.css({
                                                    width: '',
                                                    height: ''
                                                });
                                                dropZoneItem.html('<div	class="cms-block-picker"></div>' + data);
                                            });
                                    },
                                    over: function(event, ui) {

                                    }
                                });
                                $('.colDrag').draggable({
                                    helper: function(e) {
                                        return $('<div data-type="' + $(e.target).attr('data-type') + '" data-id="' + $(e.target).attr('data-id') + '">').addClass('block').text($(e.target).text());
                                    }
                                });
                            }
                            setBarToggles(ui.item);
                            $(ui.item).find('i.toggle').click();
                            let customEvent = new CustomEvent('ckedit-drop', {
                                detail: {
                                    data: data,
                                    editor: editor,
                                    item: ui.item
                                }
                            });
                            window.dispatchEvent(customEvent);
                        })
                }
            }
        });
    }
    var dlgStationRemove = $('#dlg-station-remove').dialog({
        autoOpen: false,
        modal: true,
        buttons: [{
            text: 'Ja',
            class: 'ok',
            click: function() {
                var list = selectedStation.parent();
                selectedStation.remove();
                station_reorder(list);
                selectedStation = null;
                $(this).dialog("close");
            }
        }, {
            text: 'Abbrechen',
            class: 'cancel',
            click: function() {
                $(this).dialog("close");
            }
        }]

    });
    var selectedStation = null;
    /* / Drag &	Drop & Sortable	*/
    $('.station-remove').on('click', function(event) {
        selectedStation = $(this).closest('.row').parent();
        dlgStationRemove.dialog("open");
    });



    /* Seite löschen */
    var dlg_delete = $("#dlg-delete").dialog({
        autoOpen: false,
        modal: true
    });
    $('#cms-delete').on('click', function(event) {
        // deletePage
        dlg_delete.dialog("open");
        return false;
    });
    $("#dlg-delete button.ok").on('click', function(event) {
        var data = {
            id: $(this).attr('data-id')
        };
        dlg_delete.dialog("close");
        $('#worker-message').html('Seite wird gelöscht.');
        $('#worker').show();
        $.ajax({
                type: 'POST',
                url: '/Handler/HvD/PageDelete',
                data: {
                    data: data
                }
            })
            .done(function(data, state, jqxhr) {

                if (data === 'ok') {
                    location.href = '/hvd/page-new/';
                } else {
                    $('#worker').hide();
                    alert("Nicht Gelöscht!");
                }

            })
            .fail(function(data, textStatus, errorThrown) {
                console.debug(textStatus);
                console.debug(errorThrown);
                console.debug(data);
            });

    });
    $("#dlg-delete button.cancel").on('click', function(event) {
        dlg_delete.dialog("close");
    });
    /* Speichern */
    $('#cms-save').on('click', function(event) {
        // console.log($('#cms-save'));
        let customEvent = new CustomEvent('cms-save', {
            bubbles: true,
            cancelable: true,
            detail: {
                zone: document.querySelectorAll('.cmsZone .cms-block')
            }
        });
        // customEvent.initEvent('myevent', true, true);
        if (!window.dispatchEvent(customEvent)) {
            return;
        }

        // validieren
        if (!validate()) {
            $('#dlg-info .dlg-body').html('Seite wurde nicht gespeichert.<br />Bitte füllen Sie alle Felder aus');
            $('#dlg-info').dialog({
                autoOpen: true,
                modal: true,
                title: "Fehler beim Speichern",
                buttons: [{
                    text: 'Ok',
                    class: 'ok',
                    click: function() {
                        $(this).dialog("close");
                    }
                }]

            });
            return;
        }
        if ($(this).attr('data-redir') === 'true') {
            $('#worker-message').html('Seite wird erstellt.');
        } else {
            $('#worker-message').html('');
        }

        savePage(1, /page\-new/.test(window.location.href), 'Dokument', 'Dokument "' + $('#page-title').val() + '" gespeichert');

    });


    /* Seitenvorschau */
    $('#cms-preview').on('click', function(event) {
        // validieren
        if (!validate()) {
            console.debug("err");
            return;
        }
        savePage(0, false, 'Entwurf', 'Entwurf "' + $('#page-title').val() + '" gespeichert');
        var url = $('#page-path').val();
        var parent = $('#page-parentId option:selected').text();

        var pId = parseInt($('#page-id').val());
        for (var i = 0; i < window.quickfind.length; i++) {
            if (parseInt(window.quickfind[i].id) === pId) {
                url = window.quickfind[i].path;
                break;
            }
        }
        if (!url.startsWith('/')) {
            url = '/' + url;
        }
        var path = '//' + location.host + '' + url + '/preview';
        var win = window.open(path, '_blank');
        win.focus();

    });
    /* Entwurf laden */
    $('#cms-preview-load').on('click', function(event) {
        $('#worker-message').html('Entwurf wird geladen');
        $('#worker').show();
        location.href = '//' + location.host + '/hvd/page-edit/' + page.id + '-e';
    });
    $('#cms-preview-save').on('click', function(event) {
        // validieren
        if (!validate()) {
            console.debug("err");
            return;
        }
        // wenn nicht im entwurfsmodus dann redirect
        $('#worker-message').html('');
        if ($(this).attr('data-redir') === 'true') {
            savePage(0, true, 'Entwurf', 'Entwurf "' + $('#page-title').val() + '" gespeichert');
        } else {
            savePage(0, false, 'Entwurf', 'Entwurf "' + $('#page-title').val() + '" gespeichert');
        }
        return false;
    });



    /* Seite freischalten */
    $('#cms-publish').on('click', function(event) {
        $('#worker-message').html('');
        savePage(1, true, 'Entwurf', 'Entwurf "' + $('#page-title').val() + '"  veröffentlicht');
    });

    /* Seite seichern */
    function savePage($public, redirect, toastTitle, toastMessage) {
        $('#worker').show();
        var $items = $('.cms-block');
        var pageItems = new Array();
        for (var i = 0; i < $items.length; i++) {
            pageItems[i] = new Object();
            pageItems[i]['id'] = $($items[i]).attr('data-id');
            pageItems[i]['type'] = $($items[i]).attr('data-type');
            pageItems[i]['pegel'] = $($items[i]).attr('data-pegel');
            pageItems[i]['sort'] = (i + 1) * 10;
            pageItems[i]['data'] = new Array();
            // Daten in	Tags mit dem Attribut "data-name"
            // data-name gibt den Bezeichner an	der	zum	auslesen wieder	verwendet wird.
            var $data = $($items[i]).find('[data-name]');

            for (var n = 0; n < $data.length; n++) {
                pageItems[i]['data'][n] = new Object();
                pageItems[i]['data'][n]['dataname'] = $($data[n]).attr('data-name');
                if ($($data[n]).val()) {
                    if ($($data[n])[0].type === 'checkbox') {
                        if ($($data[n])[0].checked) {
                            pageItems[i]['data'][n]['datavalue'] = $($data[n]).val();
                        } else {
                            pageItems[i]['data'][n]['datavalue'] = '';
                        }
                    } else {
                        pageItems[i]['data'][n]['datavalue'] = $($data[n]).val();
                    }
                } else {
                    pageItems[i]['data'][n]['datavalue'] = $($data[n]).html();
                }
            }
        }

        var $formData = $('.form-control');
        var pageProp = {
            'page-id': page.id
        };
        for (var i = 0; i < $formData.length; i++) {
            pageProp[$formData[i].name] = $($formData[i]).val();
        }
        var pageData = {
            data: {
                'public': $public,
                'prop': pageProp,
                'data': pageItems
            }
        };
        if (redirect) {
            $('#worker').show();
        }
        $.ajax({
                type: 'POST',
                url: '/Handler/HvD/Save',
                dataType: 'json',
                data: pageData
            })
            .done(function(data, state, jqxhr) {
                page.id = data.ID;
                $('#page-id').val(data.ID)
                tools.toast(toastTitle, toastMessage);
                if (redirect) {
                    if ($public) {
                        location.href = '//' + location.host + '/hvd/page-edit/' + data.ID;
                    } else {
                        location.href = '//' + location.host + '/hvd/page-edit/' + data.ID + '-e';
                    }
                }
                $('#worker').hide();
            })
            .fail(function(data, textStatus, errorThrown) {
                console.debug(textStatus);
                console.debug(errorThrown);
            });
    }

    /* Felder validieren */
    function validate() {
        var $items = $('.cms-required');
        var retVal = true;
        // Pfad ok?
        if ($('#page-path').next().hasClass('err')) {
            $('#page-path').addClass('err-info');
            retVal = false;
        } else {
            $('#page-path').removeClass('err-info');
        }

        for (var i = 0; i < $items.length; i++) {
            if ($($items[i]).val() === '') {
                $($items[i]).addClass('err-info');
                if ($items[i].ph === undefined) {
                    $items[i].ph = $items[i].placeholder;
                }
                $items[i].placeholder = $items[i].ph + ': Bitte tragen Sie einen gültigen Wert ein';
                $($items[i]).trigger('focus'); // focus();
                retVal = false;
            } else {
                $($items[i]).css('border', '');
            }
        }
        return retVal;
    }
    /**
     * hinzufuegen eines on click events auf editierbare bilder im CMS zum oeffnen eines edit popups
     */
    $('.editImage').click(function(ev) {

    });

    function station_reorder(list) {
        $(list).find('>.move,>.row').each(function(i, el) {
            $(el).find('input.stationId').attr('data-name', 'stationId-' + (i + 1));
            $(el).find('input.type').attr('data-name', 'type-' + (i + 1));
        });
    }

}
// );

